class LookbookGallery {
  constructor(root) {
    this.root = root;
    this.modal = root.querySelector('[data-lookbook-modal]');
    this.slider = root.querySelector('[data-lookbook-slider]');
    this.slides = Array.from(root.querySelectorAll('[data-lookbook-slide]'));
    this.total = this.slides.length;
    this.index = 0;

    if (!this.modal || !this.slider || this.total === 0) return;

    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchMove = this.onTouchMove.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);

    this.root.addEventListener('click', this.onClick);
    document.addEventListener('keydown', this.onKeydown);

    this.content = root.querySelector('[data-lookbook-modal-content]');
    this.content.addEventListener('touchstart', this.onTouchStart, { passive: true });
    this.content.addEventListener('touchmove', this.onTouchMove, { passive: true });
    this.content.addEventListener('touchend', this.onTouchEnd);

    this.dragging = false;
    this.startX = 0;
    this.startTranslate = 0;
  }

  get isOpen() {
    return this.modal.classList.contains('is-active');
  }

  update(animate = true) {
    this.slider.style.transition = animate
      ? 'transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
      : 'none';
    this.slider.style.transform = `translateX(${-this.index * 100}%)`;
  }

  open(index) {
    this.index = index;
    this.modal.classList.add('is-active');
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lookbook-modal-open');
    this.update(false);
  }

  close() {
    this.modal.classList.remove('is-active');
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lookbook-modal-open');
  }

  next() {
    this.index = (this.index + 1) % this.total;
    this.update();
  }

  prev() {
    this.index = (this.index - 1 + this.total) % this.total;
    this.update();
  }

  onClick(event) {
    const trigger = event.target.closest('[data-lookbook-open]');
    if (trigger && this.root.contains(trigger)) {
      this.open(parseInt(trigger.dataset.lookbookOpen, 10) || 0);
      return;
    }

    if (!this.isOpen) return;

    if (event.target.closest('[data-lookbook-next]')) {
      this.next();
    } else if (event.target.closest('[data-lookbook-prev]')) {
      this.prev();
    } else if (
      event.target.closest('[data-lookbook-close]') ||
      event.target === this.modal ||
      event.target.matches('[data-lookbook-slide]')
    ) {
      this.close();
    }
  }

  onKeydown(event) {
    if (!this.isOpen) return;
    if (event.key === 'Escape') this.close();
    else if (event.key === 'ArrowRight') this.next();
    else if (event.key === 'ArrowLeft') this.prev();
  }

  onTouchStart(event) {
    if (!this.isOpen) return;
    if (event.target.closest('[data-lookbook-nav]')) return;
    if (event.target.closest('[data-lookbook-product]')) return;

    this.dragging = true;
    this.startX = event.touches[0].clientX;
    this.startTranslate = -this.index * this.content.offsetWidth;
    this.slider.style.transition = 'none';
  }

  onTouchMove(event) {
    if (!this.dragging) return;
    const delta = event.touches[0].clientX - this.startX;
    this.slider.style.transform = `translateX(${this.startTranslate + delta}px)`;
  }

  onTouchEnd(event) {
    if (!this.dragging) return;
    this.dragging = false;

    const delta = event.changedTouches[0].clientX - this.startX;
    if (delta < -50) this.index = Math.min(this.index + 1, this.total - 1);
    else if (delta > 50) this.index = Math.max(this.index - 1, 0);
    this.update(true);
  }
}

function initLookbooks(scope) {
  (scope || document).querySelectorAll('[data-lookbook]').forEach((root) => {
    if (root.dataset.lookbookReady === 'true') return;
    root.dataset.lookbookReady = 'true';
    new LookbookGallery(root);
  });
}

document.addEventListener('DOMContentLoaded', () => initLookbooks());
document.addEventListener('shopify:section:load', (event) => initLookbooks(event.target));
